import { Box, Button, Grid2 } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import useMediaQuery from '@mui/material/useMediaQuery';
import Axios from "axios";
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as XLSX from "xlsx";
import consts from "../../constant";
import Header from '../Header/Header';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {Tooltip } from "@mui/material";


const drawerWidth = 260;

const Kyc = () => {
  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.up('lg'));
  const navigate = useNavigate()
  const tabelHeader = [
    "S.no", "Date & Time", "First Name",
    "Last Name", "Email", "Gender",
    "DOB", "Country", "State",
    "City", "Zip / Postal Code", , "Address",
    "Kyc Verify",
    "Reason", "Action"];
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalpage] = useState()
  const [search, setSearch] = useState("");
  const [filtersReset, setFiltersReset] = useState(false)
  const [data, setData] = useState([]);


  const getKyc = async () => {
    try {
      if (localStorage.getItem("adminToken")) {

        let payload = { type: "all" };

        if (search) {
          payload = { search };
          payload.type = "all"
        }

        Axios.post(`${consts.BackendUrl}/admin/getkyclist?limit=${limit}&page=${page}`, payload, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Content-Type, Authorization",
            "Access-Control-Allow-Credentials": "true",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            Authorization: localStorage.getItem("adminToken"),
          },
        })
          .then((res) => {
            if (res?.data?.result.docs.length > 0) {
              setTotalpage(res?.data?.result?.totalPages)
              setData(res.data.result)
            }
          })
          .catch((err) => console.log(err.response?.data, "errrr"));
      } else {
        navigate(`/${consts.route + '/login'}`);
      }
    } catch (error) {
      console.log(error, "error getting kyc detailes");
    }
  };

  useEffect(() => {
    getKyc();
  }, [page, limit]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleReset = () => {
    setSearch("");
    setFiltersReset(true)
  };

  useEffect(() => {
    if (filtersReset) {
      getKyc();
      setFiltersReset(false);
    }
  }, [filtersReset]);

  const handleDownload = () => {
    const formData = data.map((item, index) => ({
      "S.No": index + 1,
      Name: item.name,
      Email: item.email,
      "Email Verify": item.email_verify ? "Verified" : "Not Verified",
      "2FA": item.twoFA ? "Enabled" : "Disabled",
      "KYC Verify": item.kyc_verify ? "Verified" : "Not Verified",
      Role: item.role,
      "Is Google": item.isGoogle ? "Yes" : "No",
      "Profile Picture": item.profilePicture ? "Yes" : "No",
    }));
    const ws = XLSX.utils.json_to_sheet(formData, { origin: "A2" });

    const title = [["User Data Report"]];
    XLSX.utils.sheet_add_aoa(ws, title, { origin: "A1" });

    const mergeRange = {
      s: { r: 0, c: 0 },
      e: { r: 0, c: Object.keys(formData[0]).length - 1 },
    };
    if (!ws["!merges"]) ws["!merges"] = [];
    ws["!merges"].push(mergeRange);

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "4F81BD" } },
    };
    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
    };

    ws["A1"].s = titleStyle;

    const headerRange = Object.keys(formData[0]).map((_, colIndex) =>
      XLSX.utils.encode_cell({ r: 1, c: colIndex })
    );
    headerRange.forEach((cell) => (ws[cell].s = headerStyle));

    ws["!cols"] = Object.keys(formData[0]).map((key) => ({
      wch: key.length + 10,
    }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    XLSX.writeFile(wb, "UserDataReport.xlsx");
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    getKyc();
  };

  return (
    <div className="UserList">
      <Box sx={{ display: lg ? 'flex' : 'block' }}>
        <Header />
        <Box
          component="main"
          sx={{ flexGrow: 1, p: 5, width: { lg: `calc(100% - ${drawerWidth}px)` }, marginTop: '50px' }}
        >
          <h2 style={{ color: 'white' }} >KYC Lists</h2>
          <Grid2 container spacing={2}>
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>

              <form onSubmit={handleSearchSubmit}>
                <input
                  id=""
                  style={{
                    width: "300px",
                    height: "40px",
                    border: "1px solid white",
                    backgroundColor: "#091620",
                    color: "white",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                  type="text"
                  value={search}
                  onChange={handleSearch}
                  placeholder="Search users..."
                />


                <Button
                  style={{ height: "40px", marginLeft: "15px" }}
                  variant="contained"
                  type="submit"
                >
                  Search
                </Button>
                <Button
                  style={{ height: "40px", marginLeft: "15px" }}
                  variant="contained"
                  type="button"
                  onClick={handleReset}
                >
                  Reset
                </Button>
                <div style={{ marginTop: "10px" }}>
                  <small style={{ color: "lightgray", marginTop: "5px" }}>
                    You can search using First Name, Last Name, State, Country, City, or Status (Pending, Verified, or Rejected).
                  </small>
                </div>
                {/* <Button
                  onClick={handleDownload}
                  type="download"
                  style={{ height: "50px", marginLeft: "10px" }}
                  variant="contained"
                >
                  Excel To Export
                </Button> */}
              </form>

              <div className="custom_table">
                <TableContainer style={{ overflow: "auto" }} >
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        {tabelHeader.map((item) => (
                          <TableCell align="center">{item}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data?.docs?.map((value, index) => (
                        <TableRow
                          key={index}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            {index + 1}
                          </TableCell>

                          <TableCell align="center" style={{ color: "white" }}>
                            {value?.createdAt ? new Date(value.createdAt).toLocaleString('en-IN') : "N/A"}
                          </TableCell>


                          <TableCell align="center" style={{ color: "white" }}>
                            {value?.first_name}
                          </TableCell>
                          <TableCell align="center" style={{ color: "white" }}>
                            {value?.last_name}
                          </TableCell>

                          <TableCell align="center" style={{ color: "white" }}>
                            {value?.user_id?.email}
                          </TableCell>

                          <TableCell align="center" style={{ color: "white" }}>
                            {value?.gender}
                          </TableCell>
                          <TableCell align="center" style={{ color: "white" }}>
                            {value?.dob}
                          </TableCell>
                          <TableCell align="center" style={{ color: "white" }}>
                            {value?.country}
                          </TableCell>
                          <TableCell align="center" style={{ color: "white" }}>
                            {value?.state}
                          </TableCell>
                          <TableCell align="center" style={{ color: "white" }}>
                            {value?.city}
                          </TableCell>
                          <TableCell align="center" style={{ color: "white" }}>
                            {value?.city}
                          </TableCell>
                          <TableCell align="center" style={{ color: "white" }}>
                            {value?.address?.split(" ")?.slice(0, 5)}
                          </TableCell>

                          <TableCell
                            align="center"
                            style={{
                              color:
                                value?.status == "0"
                                  ? "orange"
                                  : value?.status == "1"
                                    ? "green"
                                    : value?.status == "2"
                                      ? "red"
                                      : "white",
                            }}
                          >
                            {value?.status == "0"
                              ? "Pending"
                              : value?.status == "1"
                                ? "Verified"
                                : value?.status == "2"
                                  ? "Declined"
                                  : ""}
                          </TableCell>

                          <TableCell align="center" style={{ color: "white" }}>
                            {value?.reason ? value?.reason : "-"}
                          </TableCell>
                          <TableCell align="center">
                            <Tooltip
                              title="View"
                              arrow
                              placement="top"
                              componentsProps={{
                                tooltip: {
                                  sx: {
                                    backgroundColor: "purple",
                                    color: "white", 
                                    fontSize: "14px", 
                                    fontWeight: "bold",
                                    padding: "6px 12px" 
                                  }
                                },
                                arrow: {
                                  sx: {
                                    color: "purple" 
                                  }
                                }
                              }}
                            >
                              <Button variant='contained'
                                onClick={() => {
                                  navigate(`/${consts?.route + '/kycdetails'}`, { state: value });
                                }}
                                className="edit-btn"
                              >
                                <VisibilityOutlinedIcon />
                              </Button>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Pagination className='pagnation'
                  count={totalPage}
                  page={page}
                  onChange={(event, value) => {
                    setPage(value);
                  }}
                  variant="outlined"
                  color='primary'
                  shape="rounded" />
              </div>

            </Grid2>
          </Grid2>
        </Box>
      </Box>
    </div>
  );
};

export default Kyc;
